import { render, staticRenderFns } from "./PageHeaderBox.vue?vue&type=template&id=76f9dff0&scoped=true"
import script from "./PageHeaderBox.vue?vue&type=script&lang=js"
export * from "./PageHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderBox.vue?vue&type=style&index=0&id=76f9dff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9dff0",
  null
  
)

export default component.exports